var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ContentfulApiClient } from './contentful.api.client';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import axios from 'axios';
const BASE_URL_TOKEN = symbolToken('BASE_URL_TOKEN', false);
export const CONTENTFUL_API_TOKEN = symbolToken('CONTENTFUL_API_TOKEN');
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AXIOS_TOKEN_ContentfulProxy = symbolToken('AXIOS_TOKEN', false);
let ContentfulApi = class ContentfulApi {
    constructor(baseUrl, axiosInstance = axios) {
        Object.defineProperty(this, "baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: baseUrl
        });
        Object.defineProperty(this, "axiosInstance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: axiosInstance
        });
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Load contentful object
         */
        Object.defineProperty(this, "getContentfulData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (options, cancelToken) => __awaiter(this, void 0, void 0, function* () {
                const { entryType, codeId, include, isPreview } = options;
                if (!entryType) {
                    throw new Error('entryType cannot be empty');
                }
                if (!codeId) {
                    throw new Error('codeId cannot be empty');
                }
                const data = yield this.apiClient.getEntry(entryType, codeId, include !== null && include !== void 0 ? include : 10, isPreview !== null && isPreview !== void 0 ? isPreview : false, cancelToken);
                return data;
            })
        });
        this.apiClient = new ContentfulApiClient(baseUrl, axiosInstance);
    }
};
ContentfulApi = __decorate([
    injectable(),
    __param(0, inject(BASE_URL_TOKEN)),
    __param(0, optional()),
    __param(1, inject(AXIOS_TOKEN_ContentfulProxy)),
    __param(1, optional()),
    __metadata("design:paramtypes", [String, Object])
], ContentfulApi);
export { ContentfulApi };
//# sourceMappingURL=contentful.api.js.map